import { R } from '@core/utils/r';
import { Endpoint } from '../endpoint';
import {
  FormResponse,
  FormId,
  CompactFormResponse,
  ElkImportEnvironment,
  ElkProjectImportInput,
  ElkProjectImportResponse,
} from '@business/entities/form';
import { CompactFileFolderResponse, FileResponse } from '@business/entities/file';
import { OrgId } from '@business/entities/organization';

export function fetchForms(fullResponse: boolean) {
  const params = R.objectCompact({ fullResponse });
  return Endpoint.get<CompactFormResponse[]>(`@gc/forms`, { params });
}

/** Staging / Prod Forms/Customer Import: Elkstone project → customer (created / updated) → forms. */
export function importElkProject(environment: ElkImportEnvironment, data: ElkProjectImportInput) {
  const path = environment === 'production' ? 'prod' : 'staging';
  return Endpoint.post<ElkProjectImportResponse>(`@gc/elk-form-import/${path}`, { data });
}

export function fetchForm(id: FormId) {
  return Endpoint.get<FormResponse>(`@gc/forms/form/${id}`);
}

export function createForm(data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@gc/forms`, { data });
}

export function updateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.patch<FormResponse>(`@gc/forms/${id}`, { data });
}

export function deleteForm(id: FormId) {
  return Endpoint.delete<void>(`@gc/forms/${id}`);
}

export function duplicateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@gc/forms/duplicate/${id}`, { data });
}

export function saveFormFields(id: FormId, data: Pick<FormResponse, 'fields'>) {
  return Endpoint.post<FormResponse>(`@gc/forms/save-fields/${id}`, { data });
}

export function deleteFormShare(id: string) {
  return Endpoint.delete<void>(`@gc/forms/delete-share/${id}`);
}

export function getOrgFileForms(orgId: OrgId) {
  return Endpoint.get<CompactFileFolderResponse[]>(`@gc/forms/org-file-forms/${orgId}`);
}

export function fetchFormVariables(ids?: FormId[]) {
  const params = R.objectCompact({ ids });
  return Endpoint.get<string[]>(`@gc/forms/variables`, { params });
}
